import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import Repeater from '@Utils/Repeater';
import {ShowOrganisationItem} from '@Selectors/builder/myArmyList/make/unit/show/show';
import {OrganisationView} from "@Selectors/builder/myArmyList/make/unit/show/view/OrganisationView";

interface IOrganisationViewProps {
  organisations: Array<OrganisationView>
}

const OrganisationsView: React.FC<OrganisationViewProps> = ({organisations}) => {

  return (
    <ul className="list-inline float-start">
      <Repeater data={organisations} indexPrefix='organisation'>
        {
          (item: ShowOrganisationItem) =>
            <li className="organisation list-inline-item">
              <img alt={item.name} src={item.logo} width="75" height="75"/>
            </li>
        }
      </Repeater>
    </ul>
  );
};

const mapStateToProps = (state: AppState, owsProps: IOrganisationViewProps) => ({
  organisations: owsProps.organisations
});

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationsView);

type OrganisationViewProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
